import { useState } from 'react';

const Drag = ({ width, height, color = '#000000' }) => {
	const [isHovering, setIsHovering] = useState(false);

	return (
		<svg
			version="1.2"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 219 192"
			width={width}
			height={height}
			onMouseEnter={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
		>
			<path
				id="Layer"
				fillRule="evenodd"
				stroke={isHovering ? 'white' : color}
				className="s0"
				d="m110.7 0.8l107.6 0.9v16.6l-107.6 0.9c-93.5 0.8-107.8 0.2-109.5-4.2-1-2.7-1-7.3 0-10 1.7-4.4 16-5 109.5-4.2zm0 50l107.6 0.9v16.6l-107.6 0.9c-93.5 0.8-107.8 0.2-109.5-4.2-1-2.7-1-7.3 0-10 1.7-4.4 16-5 109.5-4.2zm0 50l107.6 0.9v16.6l-107.6 0.9c-93.5 0.8-107.8 0.2-109.5-4.2-1-2.7-1-7.3 0-10 1.7-4.4 16-5 109.5-4.2zm-42.3 49.2h83.2l-41.6 41.6z"
			/>
		</svg>
	);
};

export default Drag;
